//
import * as types from "../types/index";
import { core } from "./core";

export const getLeaveRequest = (queryString) => {
  return core.API(
    "GET",
    `/dashboard/leaves/${queryString ? `?${queryString}` : ""}`,
    types.GET_LEAVE_REQUESTS,
    types.GET_LEAVE_REQUESTS_SUCCESS,
    types.GET_LEAVE_REQUESTS_FAILURE
  );
};

export const getLeavesHoursPerDay = (queryString) => {
  return core.API(
    "GET",
    `/dashboard/leave-hours-per-day/${queryString ? `?${queryString}` : ""}`,
    types.GET_LEAVE_HOURS_PER_DAY,
    types.GET_LEAVE_HOURS_PER_DAY_SUCCESS,
    types.GET_LEAVE_HOURS_PER_DAY_FAILURE
  );
};

export const getLeaveHoursByReason = (queryString) => {
  return core.API(
    "GET",
    `/dashboard/leave-hours-by-reason/${queryString ? `?${queryString}` : ""}`,
    types.GET_LEAVE_HOURS_BY_REASON,
    types.GET_LEAVE_HOURS_BY_REASON_SUCCESS,
    types.GET_LEAVE_HOURS_BY_REASON_FAILURE
  );
};
